module.exports = __webpack_public_path__ + "img/yj.f9051fb6.png";